<p-dialog
  ngSkipHydration
  [header]="header"
  [modal]="true"
  [visible]="visible()"
  [position]="position()"
  [style]="{ width: '25rem' }"
  [draggable]="false"
  [focusOnShow]="false"
  [closable]="false"
  (onShow)="onShow()"
  (onHide)="onHide()">
  <span class="text-surface-500 dark:text-surface-400 block mb-8">
    {{ content }}
    <br>
    <a class="text-blue-600" [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Polityka prywatności</a>
  </span>
  <div class="inline-flex gap-2">
    <p-button [label]="acceptRequired" severity="secondary" (click)="onAcceptRequiredConsent()" size="small"/>
    <p-button [label]="acceptAll" (click)="onAcceptAllConsent()" size="small"/>
  </div>
</p-dialog>
